'use client';
import React, { SVGProps, FC } from 'react';

export const withDefaultValues =
  (Component: FC<SVGProps<SVGSVGElement>>) =>
  (props: SVGProps<SVGSVGElement>) =>
    <Component width="24px" height="24px" {...props} />;
